// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: contents;
}

:host ::ng-deep .card-body {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.card-deck :host {
  flex: 1 0 0%;
  margin-right: 0.75rem;
  margin-bottom: 0;
  margin-left: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/modules/app-common/components/card-icon/card-icon.component.scss"],"names":[],"mappings":"AAEA;EACI,iBAAA;AADJ;;AAIA;EACI,4BAAA;EACA,+BAAA;AADJ;;AAIA;EAEY,YAAA;EACR,qBAAA;EACA,gBAAA;EACA,oBAAA;AADJ","sourcesContent":["@import 'styles/core/variables.scss';\n\n:host {\n    display: contents;\n}\n\n:host ::ng-deep .card-body {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n}\n\n.card-deck :host {\n    -webkit-box-flex: 1;\n            flex: 1 0 0%;\n    margin-right: 0.75rem;\n    margin-bottom: 0;\n    margin-left: 0.75rem;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
